import React from "react";
import { Box, Stack, Typography, Button } from "@mui/material";
import { Images } from "./../../assets/common";
import TipPopup from "../TipPopup";
import Loader from "./../../components/Loader";
import ApiService from "./../../services/api-service";
import notifier from "../Notifier";
import { getErrorString } from "../../constants/function";
import { useTranslation } from "react-i18next";
export default function TipContainer({ id, artistName, isArtist }) {
  const { t } = useTranslation("common");
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = async (amount, val, artist, currency) => {
    if (amount) {
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: isArtist ? "artist" : "playlist",
          currency: currency ? currency : "siki",
        };
        setLoading(true);
        const response = await ApiService.TIP_ARTIST(payload);
        setLoading(false);
        notifier.success(response["result"]);
        setOpen(false);
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpen(false);
    }
  };
  return (
    <Box
      sx={{
        padding: "20px 10px",
        border: "2px dashed #4D4D4D",
        borderRadius: "15px",
      }}
    >
      <Stack spacing={3}>
        <Stack direction="row" justifyContent="space-between">
          <Stack>
            <Typography className="fs-17">
              {t("tipContainer.header")}
            </Typography>
            <Typography className="fs-12 test-width">
              {t("tipContainer.subHeader")}
            </Typography>
          </Stack>
          <Stack>
            <img style={{ width: "50px" }} src={Images.tipOwner} alt="coin" />
          </Stack>
        </Stack>
        <Button
          sx={{ width: "100%" }}
          onClick={handleClickOpen}
          variant="outlined"
          color="default"
        >
          {t("tipContainer.button")}
        </Button>
      </Stack>
      {open ? (
        <TipPopup artist={artistName} open={open} handleClose={handleClose} />
      ) : null}
      {loading ? <Loader /> : null}
    </Box>
  );
}
